import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function FloatingContact() {
  const { lang, contactInfo } = useLanguage();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 2200);
    return () => clearTimeout(t);
  }, []);

  const phone = contactInfo.phone;
  const phoneClean = phone.replace(/\D/g, "");
  const waMessage = encodeURIComponent(
    lang === "ro"
      ? "Salut! Sunt interesat/ă de serviciile Social Destiny."
      : "Hi! I'm interested in Social Destiny's services."
  );
  const waLink = `https://wa.me/${phoneClean}?text=${waMessage}`;
  const telLink = `tel:${phone.replace(/\s/g, "")}`;
  const waLabel = lang === "ro" ? "Scrie pe WhatsApp" : "Chat on WhatsApp";
  const phoneLabel = lang === "ro" ? "Sună acum" : "Call now";

  if (!mounted) return null;

  return (
    <div
      className="hidden lg:flex fixed bottom-6 left-6 z-[80] flex-col-reverse gap-3"
      data-testid="floating-contact"
    >
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        className="group relative flex items-center"
        data-testid="floating-whatsapp"
      >
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_40px_rgba(37,211,102,0.35)] hover:scale-105 hover:shadow-[0_16px_48px_rgba(37,211,102,0.5)] transition-all duration-300">
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
          <i className="fa-brands fa-whatsapp relative text-[1.35rem] leading-none" aria-hidden />
        </span>
        <span className="ml-3 whitespace-nowrap rounded-full bg-[#3e2723] text-[#fbd9e5] px-4 py-2 text-[12px] font-semibold opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg">
          {waLabel} · {phone}
        </span>
      </a>

      <a
        href={telLink}
        className="group relative flex items-center"
        data-testid="floating-phone"
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#3e2723] text-[#fbd9e5] shadow-[0_12px_40px_rgba(62,39,35,0.3)] hover:scale-105 hover:bg-[#2a1a17] transition-all duration-300">
          <Phone className="h-5 w-5" />
        </span>
        <span className="ml-3 whitespace-nowrap rounded-full bg-[#3e2723] text-[#fbd9e5] px-4 py-2 text-[12px] font-semibold opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg">
          {phoneLabel} · {phone}
        </span>
      </a>
    </div>
  );
}
